export const courseDescriptionMaxLength = 65000;
export const defaultEditorHeadingLevel = 3;
export const teacherAvatarSize = 200;
export const teacherSectionId = 'teachers';
